import { Pipe, PipeTransform } from '@angular/core';
import { Injectable } from '@angular/core';

@Pipe({ name: 'skipcolumn' })
@Injectable()
export class SkipColumnPipe implements PipeTransform {
  transform(columns: any, addClass: string): any {
    let filteredColumns = columns;
    if (addClass == 'skipDetectedBundleId') {
      filteredColumns = filteredColumns.filter(
        item => item.key != 'detectedBundleId'
      );
    }
    return filteredColumns;
  }
}
